/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.ImgSize[_ngcontent-%COMP%] {\n  height: 16vh !important; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1mb3JtL2FkZC1pbnRlcnByZXRlcnMvYWRkLWludGVycHJldGVycy5jb21wb25lbnQuc2Fzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvYm9va2luZy1tYW5hZ2VtZW50L2Jvb2tpbmctZm9ybS9hZGQtaW50ZXJwcmV0ZXJzL2FkZC1pbnRlcnByZXRlcnMuY29tcG9uZW50LnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/booking-form/add-interpreters/add-interpreters.component.sass.shim.ngstyle.ts